import { ThemeProvider as TP } from 'styled-components';
import { addS, toPct, toPx } from 'utils/convert';
import { Colors } from 'ui/deprecated/theme/colors';

const baseSpacing = 20;
const baseFont = 14;
const defaultBorderWidth = 1;

export const THEME = {
  backgrounds: {
    grayGradiant: 'linear-gradient(180deg, #FFFFFF, #F2F2F2)',
    greenGradient: 'linear-gradient(180deg, #2bc26a, #27ae60)',
  },
  // function for border configuration
  border: ({ width = defaultBorderWidth, style = 'solid', color }) =>
    `${toPx(width)} ${style} ${color}`,
  borderRadius: {
    small: toPx(3),
    medium: toPx(4),
    large: toPx(6),
    pill: toPx(16),
    extraLarge: toPx(100),
    circle: toPct(50),
  },
  borderStyle: {
    dashedLight: `${toPx(defaultBorderWidth)} dashed ${Colors.gray10}`,
    dashed: `${toPx(defaultBorderWidth)} dashed ${Colors.gray30}`,
    solid: `${toPx(defaultBorderWidth)} solid ${Colors.gray30}`,
    solidLight: `${toPx(defaultBorderWidth)} solid ${Colors.gray10}`,
    solidThickLight: `${toPx(defaultBorderWidth * 3)} solid ${Colors.gray10}`,
  },
  borderWidth: {
    default: toPx(defaultBorderWidth),
    medium: toPx(defaultBorderWidth * 2),
    thick: toPx(defaultBorderWidth * 3),
  },
  boxShadow: {
    accent: `0px 0px 0px 2px ${Colors.accentColor}`,
    accentLarge: `0px 0px 0px 4px ${Colors.accentColor}`,
    default: `0px 0px 4px ${Colors.blackA10}`,
  },
  colors: Colors,
  fontFamily: {
    sansFontFamily:
      '"Sofia Pro", system-ui, -apple-system, BlinkMacSystemFont, "Avenir Next", Avenir, "Segoe UI", "Lucida Grande", "Helvetica Neue", Helvetica, "Fira Sans", Roboto, Noto, "Droid Sans", Cantarell, Oxygen, Ubuntu, "Franklin Gothic Medium", "Century Gothic", "Liberation Sans", sans-serif',
    sansSemanticFontFamily: "'Lato', 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'",
    monoFontFamily: 'Menlo, Monaco, Consolas, "Lucida Console", monospace',
  },
  fontSize: {
    XXL: toPx(baseFont + 8), // 22px
    XL: toPx(baseFont + 6), // 20px
    L: toPx(baseFont + 4), // 18px
    M: toPx(baseFont + 2), // 16px
    default: toPx(baseFont), // 14px
    MS: toPx(baseFont - 1), // 13px
    S: toPx(baseFont - 2), // 12px
    XS: toPx(baseFont - 4), // 10px
    header: toPx(baseFont * 2), // 28px
  },
  fontWeight: {
    light: 200,
    default: 400,
    medium: 500,
    semiBold: 600,
    bold: 'bold',
    heavy: 800,
  },
  lineHeight: {
    tight: 1.2,
  },
  outline: {
    accentFocus: `${toPx(defaultBorderWidth)} solid ${Colors.accentColor}`,
  },
  spacing: {
    triple: toPx(baseSpacing * 3), // 60px
    double: toPx(baseSpacing * 2), // 40px
    base: toPx(baseSpacing), // 20px
    threeQuarter: toPx((baseSpacing * 3) / 4), // 15px
    threeFifth: toPx((baseSpacing * 3) / 5), // 12px
    threeEights: toPx((baseSpacing * 3) / 8), // 7.5px
    half: toPx(baseSpacing / 2), // 10px
    quarter: toPx(baseSpacing / 4), // 5px
    eighth: toPx(baseSpacing / 8), // 2.5px
  },
  transitionTime: {
    base: addS(0.2),
  },
  zIndex: {
    mid: 1000,
    top: 10000,
  },
};

export const ThemeProvider = ({ children }) => <TP theme={THEME}>{children}</TP>;
